enum ToastEnum {
  Success,
  Warning,
  Info,
  Error
}
export default ToastEnum;
